'use strict';

angular.module('actionPlanCriteriaModule', [
    'services.authenticatedUser',
    'actionPlanModule'
]);